import cz from '../csCZ/not_found';

const de: typeof cz = {
	title: '404',
	text: 'Seite nicht gefunden',
};

export default de;
